import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import aboutLambicImg from '../../../images/about-lambic.webp';
import aboutAwardsImg from '../../../images/about-rewards.webp';
import aboutDrinksImg1 from '../../../images/about-drinksmeal-1.webp';
import aboutDrinksImgTashkent1 from '../../../images/about-drinksmeal-1-tashkent.webp';
import aboutDrinksImg2 from '../../../images/about-drinksmeal-2.webp';
import aboutDrinksImg3 from '../../../images/about-drinksmeal-3.webp';
import aboutComfortImg1 from '../../../images/about-comfort-1.webp';
import aboutComfortImgMobile1 from '../../../images/about-comfort-mobile-1.webp';
import aboutComfortImg2 from '../../../images/about-comfort-2.webp';
import aboutComfortImg3 from '../../../images/about-comfort-3.webp';
import aboutInfoImg from '../../../images/about-info.webp';
import classes from './AboutLambic.module.scss';
import { AboutContext } from '../../../context/aboutContext';
import { GeneralContext } from '../../../context/generalContext';
import { addressesAPI, aboutInfoLinkAPI } from '../../../services/GeneralService';
import { addressesLinkHadle } from '../../../functions/functions';
import { checkIsTashkent } from '../../../functions/checkCity/checkCity';

export default function AboutLambic() {
  const { setActiveSection } = useContext(AboutContext);
  const { path, activeLanguage, subdomain, activeCity } = useContext(GeneralContext);
  const { data: addresses } = addressesAPI.useFetchAllAddressesQuery();
  const { data: infoLinks } = aboutInfoLinkAPI.useFetchAllAboutInfoLinkQuery();

  const [addressesAll, setAddressesAll] = useState([]);
  useEffect(() => {
    let arr = [];
    if (addresses) {
      arr = addressesLinkHadle(addresses);
      setAddressesAll(arr);
    }
  }, [subdomain, addresses]);

  // при изменении path проверяем в каком разделе находимся в данный момент и устанавливаем активный раздел
  useEffect(() => {
    if (path.slice(-4) === 'info') {
      setActiveSection(1);
    }
  }, [path]);

  const isTashkent = checkIsTashkent();
  const langMapper = {
    titleBeer: [
      '',
      'Сеть Brasserie Lambic — один из\u00A0лучших пивных ресторанов столицы',
      'Lambic chain restaurant is\u00A0one of\u00A0the best beer restaurants in\u00A0Moscow',
    ],
    titleBelgian: [
      '',
      'Сеть Brasserie Lambic — один из\u00A0лучших бельгийских ресторанов столицы',
      'Lambic chain restaurant is\u00A0one of\u00A0the best Belgian restaurants in\u00A0the capital',
    ],
    text1: [
      '',
      'Говорящее название сразу подсказывает любителям пенного напитка, ' +
        'что здесь они смогут найти островок настоящей Бельгии, ' +
        'проникнуться духом классической брюссельской брассерии ' +
        'и\u00A0насладиться большим выбором отличнейшего пива. ' +
        'Здесь одинаково комфортно будут чувствовать себя как любители демократичной атмосферы, ' +
        'так и\u00A0ценители элитарных заведений.',
      'The self-explanatory name tells the foam beverage lovers that they can find ' +
        'here a\u00A0pocket of\u00A0real Belgium, embrace the spirit of\u00A0a\u00A0classical Brussels Brasserie, ' +
        'and enjoy a\u00A0large selection of\u00A0the most excellent beer. ' +
        'Both lovers of\u00A0democratic atmosphere ' +
        'and connoisseurs of\u00A0up-market establishments feel comfortable here.',
    ],
    textTashkent1: [
      '',
      'Говорящее название сразу подсказывает любителям европейской кухни, ' +
        'что здесь они смогут найти островок настоящей Бельгии, ' +
        'проникнуться духом классической брюссельской брассерии ' +
        'и\u00A0насладиться большим выбором широкой барной карты. ' +
        'Здесь одинаково комфортно будут чувствовать себя как любители демократичной атмосферы, ' +
        'так и\u00A0ценители элитарных заведений.',
      'The self-explanatory name tells the European cuisine lovers that they can find ' +
        'here a\u00A0pocket of\u00A0real Belgium, embrace the spirit of\u00A0a\u00A0classical Brussels Brasserie, ' +
        'and enjoy the wide selection of\u00A0the bar menu. ' +
        'Both lovers of\u00A0democratic atmosphere ' +
        'and connoisseurs of\u00A0up-market establishments feel comfortable here.',
    ],
    text2: [
      '',
      'Brasserie Lambic работает на\u00A0московском ресторанном рынке с\u00A02011\u00A0года. ' +
        'За\u00A0это время у\u00A0нас появилось много постоянных гостей, ' +
        'истинных ценителей уникального бельгийского пива. ' +
        'Для них посещение брассерии стало неизменным ритуалом и\u00A0стилем жизни. ' +
        'С\u00A0каждым днем число завсегдатаев растет, мы\u00A0же стараемся соответствовать ' +
        'запросам самых взыскательных гостей, ежедневно удивляя и\u00A0радуя их\u00A0новинками, ' +
        'улучшая качество обслуживания.',
      'LAMBIC has been working in\u00A0the Moscow restaurant market for over five years. ' +
        'During this time, we\u00A0have got many frequent quests, true lovers of\u00A0unique Belgian beer. ' +
        'A\u00A0visit to\u00A0the Brasserie has become an\u00A0unfailing ritual and lifestyle for them. ' +
        'Every day, a\u00A0number of\u00A0regular visitors is\u00A0constantly growing, ' +
        'and we\u00A0are trying to\u00A0meet the demands of\u00A0the most discerning guests, ' +
        'surprising and pleasing them with novelties daily and improving the quality of\u00A0service.',
    ],
    textTashkent2: [
      '',
      'Brasserie Lambic работает на\u00A0московском ресторанном рынке с\u00A02011\u00A0года. ' +
        'За\u00A0это время у\u00A0нас появилось много постоянных гостей, истинных ценителей бельгийской гастрономии. ' +
        'Для них посещение брассерии стало неизменным ритуалом и\u00A0стилем жизни. ' +
        'С\u00A0каждым днем число завсегдатаев растет, мы\u00A0же стараемся соответствовать ' +
        'запросам самых взыскательных гостей, ежедневно удивляя и\u00A0радуя их\u00A0новинками, ' +
        'улучшая качество обслуживания.',
      'LAMBIC has been working in\u00A0the Moscow restaurant market since 2011. ' +
        'During this time, we\u00A0have got many frequent quests, true lovers of\u00A0Belgian cuisine. ' +
        'A\u00A0visit to\u00A0the Brasserie has become an\u00A0unfailing ritual and lifestyle for them. ' +
        'Every day, a\u00A0number of\u00A0regular visitors is\u00A0constantly growing, ' +
        'and we\u00A0are trying to\u00A0meet the demands of\u00A0the most discerning guests, ' +
        'surprising and pleasing them with novelties daily and improving the quality of\u00A0service.',
    ],
    titleAwards: ['', 'Награды, признание сообществом', 'Awards, recognition by\u00A0the community'],
    textAwards: [
      '',
      'Brasserie Lambic уже дважды была удостоена звания лучшего пивного ресторана Москвы по\u00A0версии TripAdvisor ' +
        'и\u00A0Интернет журнала Афиша. Мы\u00A0поддерживаем активные деловые связи с\u00A0бельгийскими пивоварами. ' +
        'К\u00A0нам в\u00A0гости неоднократно приезжали именитые рестораторы и\u00A0мастера пивоваренного дела. ' +
        'Они дали высокую оценку сервису и\u00A0качеству кухни, по\u00A0достоинству оценили пивную карту, ' +
        'остались довольны общим созданным колоритом и\u00A0атмосферой заведений.',
      'The Brasserie LAMBIC has been already awarded twice with the title of\u00A0the best beer restaurant ' +
        'in\u00A0Moscow according to\u00A0TripAdvisor and Afisha Internet Magazine. ' +
        'We\u00A0maintain active business relations with Belgian brewers. ' +
        'Grand restaurateurs and masters of\u00A0brewing have visited\u00A0us on\u00A0several occasions. ' +
        'They commended the service and cuisine quality, appreciated the beer list, ' +
        'were satisfied with overall created colours and the atmosphere of\u00A0establishments.',
    ],
    textAwardsTashkent: [
      '',
      'Brasserie Lambic уже дважды была удостоена звания одного из\u00A0лучших ресторанов Москвы ' +
        'по\u00A0версии TripAdvisor и\u00A0Интернет журнала Афиша. ' +
        'К\u00A0нам в\u00A0гости неоднократно приезжали именитые рестораторы ' +
        'и\u00A0давали высокую оценку сервису и\u00A0качеству кухни, по\u00A0достоинству оценили барную карту, ' +
        'остались довольны общим созданным колоритом и\u00A0атмосферой заведений',
      'The Brasserie LAMBIC has been already awarded twice as\u00A0one of\u00A0the best restaurants ' +
        'in\u00A0Moscow according to\u00A0TripAdvisor and Afisha Internet Magazine. ' +
        'Grand restaurateurs have visited\u00A0us on\u00A0several occasions. ' +
        'They commended the service and cuisine quality, appreciated the bar menu, ' +
        'were satisfied with overall created colours and the atmosphere of\u00A0establishments.',
    ],
    titleDrinks: ['', 'Напитки и\u00A0кухня', 'Drinks and cuisine'],
    titleCuisine: ['', 'Кухня', 'Cuisine'],
    textDrinks: [
      '',
      'Бельгийское пиво\u00A0\u2014 это визитная карточка нашего ресторана. ' +
        'Именно у\u00A0нас гурманы могут найти впечатляющее разнообразие любимого эля: ' +
        'светлого, темного, классического, эксклюзивного, фруктового, пшеничного, плотного или легкого. ' +
        'Но\u00A0при этом в\u00A0Brasserie Lambic широко представлены напитки и\u00A0других известных производителей.' +
        ' Мы\u00A0взяли все лучшее из\u00A0фламандской и\u00A0европейской кухни ' +
        'и\u00A0обогатили меню эксклюзивными авторскими блюдами. ' +
        'Посетителей порадуют также приятные гастрономические комплименты от\u00A0шеф-повара.',
      'Belgian beer is\u00A0a\u00A0hallmark of\u00A0our restaurant. ' +
        'It\u00A0is\u00A0here where gourmets can find an\u00A0impressive range of\u00A0their favourite ale: ' +
        'pale, dark, classic, exclusive, fruit, wheat, thick, or\u00A0light. ' +
        'At\u00A0the same time, drinks of\u00A0other famous manufacturers are widely represented ' +
        'in\u00A0the Brasserie LAMBIC. ' +
        'We\u00A0have taken the best of\u00A0Flemish and European cuisine and ' +
        'supplemented it\u00A0with exclusive specialities of\u00A0the chef. ' +
        'Visitors will be\u00A0pleased with nice gastronomic compliments from the chef.',
    ],
    textCuisine: [
      '',
      'Мы\u00A0взяли все лучшее из\u00A0фламандской и\u00A0европейской кухни ' +
        'и\u00A0обогатили меню эксклюзивными авторскими блюдами. ' +
        'Посетителей порадуют также приятные гастрономические комплименты от\u00A0шеф-повара.',
      'We\u00A0have taken the best of\u00A0Flemish and European cuisine and ' +
        'supplemented it\u00A0with exclusive specialities of\u00A0the chef. ' +
        'Visitors will be\u00A0pleased with nice gastronomic compliments from the chef.',
    ],
    titleComfort: ['', 'Удобство и\u00A0комфорт', 'Convenience and comfort'],
    textComfort1: [
      '',
      'Наши брассерии очень удобно расположены и\u00A0находятся практически в\u00A0центре города, ' +
        'в\u00A0самых оживленных районах Москвы и\u00A0шаговой доступности от\u00A0метро.',
      'Our Brasseries are well located almost in\u00A0the centre of\u00A0the city, ' +
        'in\u00A0the most lively areas of\u00A0Moscow and within walking distance of\u00A0the metro.',
    ],
    textComfort2: [
      '',
      'Каждое из\u00A0заведений может похвастаться самобытностью интерьера и\u00A0собственным лицом, ' +
        'но\u00A0все их\u00A0объединяет национальный бельгийский колорит, сочетающийся ' +
        'с\u00A0европейской стильностью, прекрасной кухней и\u00A0высокими стандартами сервиса.',
      'Each of\u00A0the establishments can boast of\u00A0the original interior and its own identity, ' +
        'but all of\u00A0them are united by\u00A0national Belgian colour combined with the European style, ' +
        'excellent cuisine and high service standards.',
    ],
    textComfort3: [
      '',
      'Это ставит Brasserie Lambic не\u00A0только в\u00A0ряд лучших пивных заведений, ' +
        'но\u00A0и\u00A0в\u00A0ряд лучших ресторанов столицы.',
      'It\u00A0equates LAMBIC not only with the best beer establishments, but with the best capital restaurants.',
    ],
  };

  const titleText = isTashkent ? langMapper?.titleBelgian[activeLanguage] : langMapper?.titleBeer[activeLanguage];
  const text1 = isTashkent ? langMapper?.textTashkent1[activeLanguage] : langMapper?.text1[activeLanguage];
  const text2 = isTashkent ? langMapper?.textTashkent2[activeLanguage] : langMapper?.text2[activeLanguage];
  const textAwards = isTashkent
    ? langMapper?.textAwardsTashkent[activeLanguage]
    : langMapper?.textAwards[activeLanguage];
  const titleDrinksCusine = isTashkent
    ? langMapper?.titleCuisine[activeLanguage]
    : langMapper?.titleDrinks[activeLanguage];
  const textDrinksCusine = isTashkent
    ? langMapper?.textCuisine[activeLanguage]
    : langMapper?.textDrinks[activeLanguage];

  return (
    <>
      <Helmet>
        <title>{activeLanguage === 1 ? 'О нас | Brasserie Lambic' : 'About us | Brasserie Lambic'}</title>
      </Helmet>
      <LazyLoadImage className={classes.aboutLambicImg} src={aboutLambicImg} alt='lambic cartoon' />

      <div className={classes.aboutLambicArticle}>
        <div className={classes.aboutLambicTitle}>{titleText}</div>
        <p className={`${classes.aboutLambicText} ${classes.aboutLambicTextMargin}`}>{text1}</p>
        <p className={classes.aboutLambicText}>{text2}</p>
      </div>

      <div className={classes.aboutLambicArticle}>
        <LazyLoadImage className={classes.aboutAwardsImg} src={aboutAwardsImg} alt='team' />
        <div>
          <div className={classes.aboutLambicTitle}>{langMapper?.titleAwards[activeLanguage]}</div>
          <p className={classes.aboutLambicText}>{textAwards}</p>
        </div>
      </div>

      <div className={`${classes.aboutLambicArticle} ${classes.aboutLambicArticleDrinks}`}>
        <div className={classes.aboutLambicTitle}>{titleDrinksCusine}</div>
        <p className={classes.aboutLambicText}>{textDrinksCusine}</p>
        <div id='aboutDrinksImages' className={classes.aboutDrinksImages}>
          <LazyLoadImage
            className={classes.aboutDrinksImg}
            src={isTashkent ? aboutDrinksImgTashkent1 : aboutDrinksImg1}
            alt='drink'
          />
          <LazyLoadImage className={classes.aboutDrinksImg} src={aboutDrinksImg2} alt='meal' />
          <LazyLoadImage className={classes.aboutDrinksImg} src={aboutDrinksImg3} alt='chef presents the meal' />
        </div>
      </div>

      {!isTashkent && (
        <div className={`${classes.aboutLambicArticle} ${classes.aboutLambicArticleComfort}`}>
          <div id='aboutComfortImages' className={classes.aboutComfortImages}>
            <LazyLoadImage className={classes.aboutComfortImg1} src={aboutComfortImg1} alt='outdoor signboard' />
            <LazyLoadImage
              className={classes.aboutComfortImg1Mobile}
              src={aboutComfortImgMobile1}
              alt='outdoor signboard'
            />
            <div className={classes.aboutComfortImages2}>
              <div className={classes.aboutComfortImgBox}>
                <LazyLoadImage className={classes.aboutComfortImg2} src={aboutComfortImg2} alt='terrace' />
              </div>
              <div className={classes.aboutComfortImgBox}>
                <LazyLoadImage className={classes.aboutComfortImg2} src={aboutComfortImg3} alt='terrace' />
              </div>
            </div>
          </div>
          <div className={classes.aboutComfortDiv}>
            <div className={classes.aboutLambicTitle}>{langMapper?.titleComfort[activeLanguage]}</div>
            <p className={`${classes.aboutLambicText} ${classes.aboutLambicTextMargin}`}>
              {langMapper?.textComfort1[activeLanguage]}
            </p>
            <p className={`${classes.aboutLambicText} ${classes.aboutLambicTextMargin}`}>
              {langMapper?.textComfort2[activeLanguage]}
            </p>
            <p className={classes.aboutLambicText}>{langMapper?.textComfort3[activeLanguage]}</p>
          </div>
        </div>
      )}

      <div className={classes.aboutLambicArticle}>
        <div className={classes.aboutLambicTitle}>{activeLanguage === 1 ? 'Адреса ресторанов' : 'Addresses'}</div>
        <div className={classes.aboutLambicAddresses}>
          {addressesAll.map(address => (
            <a
              href={
                address.id === 44618
                  ? 'https://seafoodbastards.ru'
                  : activeLanguage === 1
                    ? `//${address.subdomainLink}`
                    : `//${address.subdomainLink}/en`
              }
              className={`${classes.aboutLambicText} ${classes.aboutLambicTextLink}`}
              key={address.id}
            >
              {activeLanguage === 1 ? address.name : address.name_en || address.name}
            </a>
          ))}
        </div>
      </div>

      {!isTashkent && (
        <div className={`${classes.aboutLambicArticle} ${classes.aboutLambicArticleInfo}`}>
          <div className={classes.aboutLambicInfoDiv}>
            <div className={classes.aboutLambicTitle}>
              {activeLanguage === 1 ? 'Дополнительная информация' : 'Additional information'}
            </div>
            <div className={classes.aboutLambicInfoLinks}>
              {infoLinks &&
                infoLinks.map(infoLink => (
                  <Link
                    to={activeLanguage === 1 ? infoLink.link : `/en${infoLink.link}`}
                    className={`${classes.aboutLambicText} ${classes.aboutLambicTextLink}`}
                    key={infoLink.id}
                    // onClick={() => window.scrollTo(0, 0)}
                  >
                    {activeLanguage === 1 ? infoLink.name : infoLink.name_en || infoLink.name}
                  </Link>
                ))}
            </div>
          </div>
          <LazyLoadImage className={classes.aboutLambicInfoImg} src={aboutInfoImg} alt='outdoor cartoon view' />
        </div>
      )}
    </>
  );
}
